module.exports = __webpack_public_path__ + "static/media/clockwise.f8ea2ec4.svg";